export default "__VITE_ASSET__d05046fb__"